import 'core-js/es/array';
import * as React from 'react';
import './UploadForm.css';

interface UploadFormProps {
  fileListHandler: (files: File[]) => void;
}

export class UploadForm extends React.Component<UploadFormProps> {
  constructor(props: UploadFormProps) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  public render() {
    return (
      <div>
        <h2><span>アップロードファイル選択</span></h2>
        <form id="Upload-Form">
          <input className="CYO-Selector" type="file" multiple={true} onChange={this.onChange}/>
        </form>
      </div>
    );
  }

  private onChange(event: React.ChangeEvent<HTMLInputElement>) {
    const files: File[] = Array.from(event.target.files || []);
    this.props.fileListHandler(files);
  }
}